// @flow
import React from 'react';
import Dropdown from '@localytics/loc-components/lib/Dropdown';
import {
  pluralize,
  toMinutes,
  fromMinutes,
  HOUR,
  DAY
} from '../util/TimeUtils';
import './stylesheets/DurationPicker.scss';

type DurationPickerState = {
  unit: string,
  value: number,
  unitLabel: string,
  valueLabel: string
};

type DurationPickerProps = {
  minutes: number,
  unit: string,
  updateTime: Function,
  disabled: boolean
};

class DurationPicker extends React.Component<
  DurationPickerProps,
  DurationPickerState
> {
  constructor(props: DurationPickerProps) {
    super(props);

    const { minutes, unit } = props;
    const timeUnit = unit || HOUR;
    const value = fromMinutes(minutes, timeUnit) || 1;
    this.state = {
      unit: timeUnit,
      value,
      unitLabel: pluralize(value, timeUnit),
      valueLabel: `${value}`
    };
  }

  updateValue: Function = e => {
    const { updateTime } = this.props;
    const { unit } = this.state;
    const { value } = e.target;

    if (e.target.checkValidity()) {
      this.setState({
        value,
        valueLabel: value
      });

      updateTime({
        minutes: toMinutes(+value, unit),
        unit
      });
    }
  };

  updateUnit: Function = ({ value: unit }) => {
    const { updateTime } = this.props;
    const { value } = this.state;

    this.setState({
      unit,
      unitLabel: pluralize(unit || 1, unit)
    });

    updateTime({
      minutes: toMinutes(+value, unit),
      unit
    });
  };

  render() {
    const { disabled } = this.props;
    const { unit, value, unitLabel, valueLabel } = this.state; // eslint-disable-line
    return (
      <div className="DurationPicker__Container">
        <input
          onChange={this.updateValue}
          onInvalid={e => e.preventDefault()}
          value={valueLabel}
          type="number"
          step={1}
          min={1}
          className="DurationPicker__Input"
          disabled={disabled}
        />
        <Dropdown
          name="jeffery"
          className="DurationPicker__Dropdown"
          disabled={disabled}
          selectedValue={{
            value: unit,
            label: `${unit}s`
          }}
          options={[
            {
              value: HOUR,
              label: `${HOUR}s`
            },
            {
              value: DAY,
              label: `${DAY}s`
            }
          ].filter(o => o.value !== unit)}
          onSelect={this.updateUnit}
          clearable={false}
        />
      </div>
    );
  }
}

export default DurationPicker;



// WEBPACK FOOTER //
// ./src/components/DurationPicker.jsx